/**
 * WordPress dependencies
 */
import { createContext, useContext } from '@wordpress/element';

/**
 * Internal dependencies
 */

const ToggleGroupControlContext = createContext({});
ToggleGroupControlContext.displayName = 'ToggleGroupControlContext';
export const useToggleGroupControlContext = () => useContext(ToggleGroupControlContext);
export default ToggleGroupControlContext;